/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ServiceInfo, ServiceInfo$inboundSchema } from "./serviceinfo.js";

/**
 * OpenTelemetry log record
 */
export type TelemetryLogRecord = {
  /**
   * Log attributes as JSON object
   */
  attributes: any;
  /**
   * The primary log message
   */
  body: string;
  /**
   * Log record ID
   */
  id: string;
  /**
   * Unix time in nanoseconds when event was observed (string for JS int64 precision)
   */
  observedTimeUnixNano: string;
  /**
   * Resource attributes as JSON object
   */
  resourceAttributes: any;
  /**
   * Service information
   */
  service: ServiceInfo;
  /**
   * Text representation of severity
   */
  severityText?: string | undefined;
  /**
   * W3C span ID (16 hex characters)
   */
  spanId?: string | undefined;
  /**
   * Unix time in nanoseconds when event occurred (string for JS int64 precision)
   */
  timeUnixNano: string;
  /**
   * W3C trace ID (32 hex characters)
   */
  traceId?: string | undefined;
};

/** @internal */
export const TelemetryLogRecord$inboundSchema: z.ZodMiniType<
  TelemetryLogRecord,
  unknown
> = z.pipe(
  z.object({
    attributes: z.any(),
    body: z.string(),
    id: z.string(),
    observed_time_unix_nano: z.string(),
    resource_attributes: z.any(),
    service: ServiceInfo$inboundSchema,
    severity_text: z.optional(z.string()),
    span_id: z.optional(z.string()),
    time_unix_nano: z.string(),
    trace_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "observed_time_unix_nano": "observedTimeUnixNano",
      "resource_attributes": "resourceAttributes",
      "severity_text": "severityText",
      "span_id": "spanId",
      "time_unix_nano": "timeUnixNano",
      "trace_id": "traceId",
    });
  }),
);

export function telemetryLogRecordFromJSON(
  jsonString: string,
): SafeParseResult<TelemetryLogRecord, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TelemetryLogRecord$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TelemetryLogRecord' from JSON`,
  );
}
